export function formatGearType(gearType: string): string {
  if (gearType === "manual") {
    return "Schaltwagen";
  } else if (gearType === "automatic") {
    return "Automatik";
  } else if (gearType === "electric") {
    return "Elektrisch";
  } else {
    return gearType;
  }
}
